export enum TooltipPosition {
  IS_TOP = 'is-top',
  IS_BOTTOM = 'is-bottom',
  IS_LEFT = 'is-left',
  IS_RIGHT = 'is-right'
}
